import Cookies from "js-cookie";
export const dropCookies = (fetchedTenantRes) => {
    var _a, _b, _c;
    Cookies.set("login-bg-URL", (_a = fetchedTenantRes === null || fetchedTenantRes === void 0 ? void 0 : fetchedTenantRes.tenantConfig) === null || _a === void 0 ? void 0 : _a.loginBgURL);
    Cookies.set("tenant-logo", (_c = (_b = fetchedTenantRes === null || fetchedTenantRes === void 0 ? void 0 : fetchedTenantRes.tenantConfig) === null || _b === void 0 ? void 0 : _b.brandLogo) === null || _c === void 0 ? void 0 : _c.darkBgLogo);
};
export const appMetaSetup = (tenant) => {
    var _a, _b, _c, _d, _e;
    const ogTitleTag = document.querySelector('meta[property="og:title"]');
    const ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    const ogImageTag = document.querySelector('meta[property="og:image"]');
    if (ogTitleTag && ogDescriptionTag && ogImageTag) {
        ogTitleTag.setAttribute("content", (_b = (_a = tenant === null || tenant === void 0 ? void 0 : tenant.tenantConfig) === null || _a === void 0 ? void 0 : _a.helmet) === null || _b === void 0 ? void 0 : _b.title);
        ogDescriptionTag.setAttribute("content", (_d = (_c = tenant === null || tenant === void 0 ? void 0 : tenant.tenantConfig) === null || _c === void 0 ? void 0 : _c.helmet) === null || _d === void 0 ? void 0 : _d.description);
        ogImageTag.setAttribute("content", (_e = tenant === null || tenant === void 0 ? void 0 : tenant.tenantConfig) === null || _e === void 0 ? void 0 : _e.brandLogo.darkBgLogo);
    }
};
export const dropAuthCookies = (key, encryptedData) => {
    // const domain = window.location.hostname.includes("localhost")
    //     ? "localhost"
    //     : ".skilliq.co";
    var _a, _b;
    // Cookies.set(key, encryptedData, {
    //     expires: 1,
    //     domain: domain,
    //     secure: true,
    //     sameSite: "none",
    // });
    try {
        console.warn("[AUTH_DEBUG]", {
            event: "COOKIE_DROP",
            source: "dropAuthCookies",
            cookieKey: key,
            cookieType: key.startsWith("LT") ? "last-login-time" : "auth-user",
            valueLength: (_a = encryptedData === null || encryptedData === void 0 ? void 0 : encryptedData.length) !== null && _a !== void 0 ? _a : 0,
            time: new Date().toISOString(),
            path: typeof window !== "undefined" ? window.location.pathname : undefined,
        });
        Cookies.set(key, encryptedData);
    }
    catch (error) {
        console.warn("[AUTH_DEBUG]", {
            event: "COOKIE_DROP_FAILED",
            source: "dropAuthCookies",
            cookieKey: key,
            cookieType: key.startsWith("LT") ? "last-login-time" : "auth-user",
            valueLength: (_b = encryptedData === null || encryptedData === void 0 ? void 0 : encryptedData.length) !== null && _b !== void 0 ? _b : 0,
            time: new Date().toISOString(),
            path: typeof window !== "undefined" ? window.location.pathname : undefined,
            error: error instanceof Error ? error.message : String(error),
            errorStack: error instanceof Error ? error.stack : undefined,
        });
        throw error;
    }
};
export const generateCookiesKey = (userId, tenantId) => {
    //Key for XOR operation
    const key = 42;
    // Perform XOR operation
    const transformedUserId = userId ^ key;
    const transformedTenantId = tenantId ^ key;
    // Convert the transformed number to a string
    const strNum = transformedTenantId.toString() + transformedUserId.toString();
    // Map digits to corresponding characters
    const charMapping = {
        "0": "P",
        "1": "S",
        "2": "I",
        "3": "D",
        "4": "A",
        "5": "B",
        "6": "C",
        "7": "E",
        "8": "F",
        "9": "G",
    };
    // Create the final string representation
    const resultString = strNum
        .split("")
        .map((char) => charMapping[char])
        .join("");
    return resultString;
};
export function isTimeDifferenceLessThan6Hours(timestamp1, timestamp2) {
    // Convert timestamps to Date objects
    const date1 = new Date(timestamp1);
    const date2 = new Date(timestamp2);
    // Calculate the time difference in milliseconds
    const timeDifferenceMs = Math.abs(date1.getTime() - date2.getTime());
    // Calculate the time difference in hours
    const timeDifferenceHours = timeDifferenceMs / (1000 * 60 * 60);
    // Check if the difference is less than 6 hours
    return timeDifferenceHours < 6;
}
